import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {
  addHoliday,
  deleteHolidays,
  getHolidays,
  getHolidaysById,
  updateHolidayById,
} from '../../../api/HolidayAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'
import {
  addDesignation,
  deleteDesignations,
  getDesignations,
  getDesignationsById,
  updateDesignationById,
} from '../../../api/DesignationAPI'

export const getDesignation = (setHoliday: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getDesignations().then((res: any) => {
    if (res.statusCode === 200) {
      setHoliday(res.data)
      setAPIStatus((prev: any) => ({...prev, loading: false, error: null}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

// form save function

export const handleSubmit = (
  InputField: {
    designationName: string
  },
  getHoliday: Function,
  setHoliday: Function,
  setEditId: Function,
  initialState: {
    designationName: string
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function
) => {
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      addDesignation(InputField).then((res) => {
        if (res.statusCode === 201) {
          toast.success(res.message)
          getHoliday(setHoliday, setAPIStatus)
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          updateDesignationById(InputField, editId).then((res: any) => {
            if (res.statusCode === 200) {
              getHoliday(setHoliday, setAPIStatus)
              toast.success(res.message)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              setEditId(null)
              setIsAddUserModalOpen(false)
            } else {
              Message(res.message, 'error')
            }
            setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
          })
        }
      })
    }
  }
}

// delete holiday

export const deleteDesignation = (
  id: string,
  getHoliday: Function,
  setHoliday: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    designationName: string
  },
  setEditId: Function,

  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteDesignations(id)
        .then((res: any) => {
          if (res.statusCode === 202) {
            getHoliday(setHoliday, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((res: any) => {
          Message(res.message, 'error')
        })
    }
  })
}
export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    designationName: string
  }
) => {
  let target = event.target as HTMLInputElement
  setInputField({
    ...InputField,
    [target.name]: target.type === 'checkbox' ? target.checked : target.value,
  })
}

//getHolidayByID

export const getDesignationById = (
  id: string,
  InputField: {
    designationName: string
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getDesignationsById(id).then((res: any) => {
    if (res) {
      setInputField({
        ...InputField,
        designationName: res.data.name,
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error') // Assuming the Message function is imported from the correct location
    }
  })
}
export const validateForm = (InputField: {designationName: string}) => {
  let cnt = 0
  const error: any = {}

  const minDesignationNameLength = 2
  const maxDesignationNameLength = 35
  const designationName = InputField.designationName.trim()

  if (!designationName) {
    cnt = cnt + 1
    error.designationName = 'Please enter a Designation Name.'
  } else if (designationName.length < minDesignationNameLength) {
    cnt = cnt + 1
    error.designationName = 'Designation Name must be at least 2 characters.'
  } else if (designationName.length > maxDesignationNameLength) {
    cnt = cnt + 1
    error.designationName = 'Designation Name must not exceed 35 characters.'
  } else if (!/^[a-zA-Z-. ]+$/.test(designationName)) {
    cnt = cnt + 1
    error.designationName =
      'Please enter a valid Designation Name using only alphabetic characters.'
  }

  return {error, cnt}
}
export const cancelSubmit = (
  setInputField: Function,
  InputField: {designationName: string},
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
